import clsx from 'clsx';
import { format } from 'date-fns';

type LabelDateProps = {
  date: string;
  label: string;
  className?: string;
  formatDate: string;
};

export const LabelDate: React.FC<LabelDateProps> = ({
  date,
  label,
  className,
  formatDate = 'yyyy-MM-dd',
}) => {
  const formattedDate = format(date, formatDate);

  return (
    <div className={clsx(className)}>
      <span className="pr-xs">{label}</span>
      <span className="font-bold">&#8226;</span>
      <span className="pl-xs">{formattedDate}</span>
    </div>
  );
};
